import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18AddB = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "nonzero",
      transform: "translate(5 5)",
      children: [/*#__PURE__*/jsx("rect", {
        width: 8,
        height: 2,
        y: 3,
        rx: 1
      }), /*#__PURE__*/jsx("rect", {
        width: 2,
        height: 8,
        x: 3,
        rx: 1
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18AddB$1 = Svg18AddB;

export { Svg18AddB$1 as default };
